import type { PayingUp, PayingUpInput } from 'generated/gql';

import { mapShareSeriesToShareSeriesInput } from './ShareSeries';

export const mapPayingUpToPayingUpInput = (payingUp: PayingUp): PayingUpInput => ({
  ownerPartyId: payingUp.owner.id,
  shareSeries: mapShareSeriesToShareSeriesInput(payingUp.shareSeries),
});
